<section class="py-5" style="background: linear-gradient(112deg, #eaf4fd 70%, #e1ffe8 100%);">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-9">
                <div class="list-banner-box d-flex flex-column flex-md-row align-items-center justify-content-between gap-4 p-4 p-md-5 rounded-4 shadow-lg text-center text-md-start position-relative">
                    <div class="d-flex align-items-center gap-3 flex-shrink-0 mb-3 mb-md-0">
            <span class="banner-cta-icon d-inline-flex align-items-center justify-content-center rounded-circle">
              <i class="fa fa-list-alt text-white fs-3"></i>
            </span>
                        <div>
                            <h2 class="fw-bold mb-1" style="font-size:1.55rem;">
                                Erstellen Sie Ihre <span class="text-primary">maßgeschneiderte Firmenliste</span> <br class="d-none d-md-block">
                                in wenigen Minuten!
                            </h2>
                            <div class="text-success mt-1" style="font-size:1.09rem;">
                                Einfach auswählen. Individuell filtern. Sofort starten.
                            </div>
                        </div>
                    </div>
                    <div>
                        <a href="/liste-konfigurieren" class="btn btn-primary btn-lg px-4 py-2 shadow banner-btn-animate">
                            Jetzt Liste konfigurieren <i class="fa fa-arrow-right ms-2"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
